import {
  ClubBean,
  ClubPropertiesSettings,
  ClubWebSettings,
  FeatureFlags,
} from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";

const publicClubApi = (apiUrl: string, clubId: number) => {
  const axiosInstance = createAxiosInstance({ apiUrl });
  const clubPrefix = `club/${clubId}/`;

  return {
    findById(id: number) {
      return axiosInstance.get<ClubBean>(`club/${id}/hosted`);
    },
    settings() {
      return axiosInstance.get<{ settings: ClubWebSettings }>(
        `${clubPrefix}hosted/settings`,
      );
    },
    propertiesSettings() {
      return axiosInstance.get<ClubPropertiesSettings>(
        `${clubPrefix}hosted/properties-settings`,
      );
    },
    featureFlags() {
      return axiosInstance.get<FeatureFlags>(
        `${clubPrefix}hosted/feature-flags`,
      );
    },
  };
};

export default publicClubApi;
